import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ae6fce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" You are offline. Some functionalities may be unavailable. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_cell = _resolveComponent("van-cell")!

  return (_openBlock(), _createBlock(_component_van_cell, null, _createSlots({ _: 2 }, [
    (_ctx.navigator && !_ctx.navigator.onLine)
      ? {
          name: "value",
          fn: _withCtx(() => [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ])
        }
      : (_ctx.shouldShowTutorial)
        ? {
            name: "value",
            fn: _withCtx(() => [
              _createVNode(_component_van_row, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Welcome to hansel. I'm Gretel, your first friend on this app. Try dropping your first gem for me, and I'll send one back! ")
                ]),
                _: 1
              })
            ])
          }
        : (_ctx.numberGemsPendingCollection > 0)
          ? {
              name: "value",
              fn: _withCtx(() => [
                _createVNode(_component_van_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, { span: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_row, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", { class: "number-label" }, _toDisplayString(_ctx.numberGemsPendingCollection), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" uncollected gem(s) ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, { span: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_row, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", { class: "number-label" }, _toDisplayString(_ctx.displayNearestGemDistance), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" to the nearest gem ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            }
          : {
              name: "value",
              fn: _withCtx(() => [
                _createVNode(_component_van_row, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" You currently have no uncollected gems~ ")
                  ]),
                  _: 1
                })
              ])
            }
  ]), 1024))
}